import { useEffect, useState } from 'react';
import {
    COMPAT_KEYS,
    STORAGE_KEYS,
    getAuthSession,
    subscribeToDomain,
    subscribeToKey
} from '../services/storage/GQStorage';

const defaultAuthSession = {
    isLoggedIn: false,
    userName: null,
    authMethod: null,
    providerId: null,
    issuedAt: null,
    schemaVersion: 1
};

export default function useAuthSession() {
    const [authSession, setAuthSession] = useState(() => getAuthSession());

    useEffect(() => {
        const refresh = () => {
            setAuthSession(getAuthSession());
        };

        const unsubAuth = subscribeToKey(STORAGE_KEYS.authSession.key, refresh);
        const unsubCompatLoggedIn = subscribeToKey(COMPAT_KEYS.IS_LOGGED_IN, refresh);
        const unsubCompatUserName = subscribeToKey(COMPAT_KEYS.USER_NAME, refresh);

        refresh();

        return () => {
            unsubAuth();
            unsubCompatLoggedIn();
            unsubCompatUserName();
        };
    }, []);

    return authSession || defaultAuthSession;
}

export const subscribeToStorageDomain = (domain, callback) => subscribeToDomain(domain, callback);
